// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__1eni4","search-form":"Search_search-form__1ag9v","search-input":"Search_search-input__x_oyK"};